var map = {
	"./1.mp4": 5489,
	"./10.mp4": 7357,
	"./11.mp4": 5368,
	"./12.mp4": 8223,
	"./13.mp4": 8714,
	"./14.mp4": 1985,
	"./15.mp4": 1676,
	"./16.mp4": 2515,
	"./2.mp4": 2702,
	"./3.mp4": 211,
	"./4.mp4": 8,
	"./5.mp4": 9949,
	"./6.mp4": 9850,
	"./7.mp4": 4335,
	"./8.mp4": 9540,
	"./9.mp4": 489
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6658;